import React, { FC, Suspense } from 'react'
import { useExchageType } from '@/utils/hooks/useExchangeType'
import { Loader } from '@/ui/kit/Loader'
import { exchangeFactory } from '@/exchanges/exchangeFactory'

const LeveragePageBinance = React.lazy(() => import('./LeveragePage.Binance'))
const LeveragePageBybit = React.lazy(() => import('./LeveragePage.Bybit'))
const LeveragePageTigerX = React.lazy(() => import('./LeveragePage.TigerX'))

const leverageMultiplePageMap: Record<string, React.LazyExoticComponent<FC>> = {
  BINANCE_BROKER_FUTURE: LeveragePageBinance,
  TIGER_X: LeveragePageTigerX,
}

const leveragPageMap: Record<string, React.LazyExoticComponent<FC>> = {
  BYBIT_BROKER: LeveragePageBybit,
}

export const LeveragePage: FC = () => {
  const { exchangeType } = useExchageType()
  const exchangeConfig = exchangeFactory[exchangeType]
  const isShowLeverageMultipleSelect = exchangeConfig.pages.leverage.multiple
  const leveragePage = isShowLeverageMultipleSelect ? leverageMultiplePageMap : leveragPageMap
  const LeveragePageComponent = leveragePage[exchangeType]

  return (
    <Suspense fallback={<Loader />}>
      <LeveragePageComponent />
    </Suspense>
  )
}
